import { gql } from "apollo-angular";

const DELETE_CROSS_REFERENCE= gql`
mutation DeleteCrossReference(
  $fromProductId: Long!
  $toProductId: Long!
) {
  deleteCrossReference(
    deleteCrossReference: {
      fromProductId: $fromProductId
      toProductId: $toProductId
    }
  ) {
    id
    crossReferenceType
    crossReferenceDescription
  }
}
`;

export default DELETE_CROSS_REFERENCE;